import React from 'react';

const Title = ({ config }) => {
  return (
    <h3 className={config.classContainer} >
      <strong className={config.classLabel}>{config.label}</strong>
    </h3>
  )
}

export default Title;